import React from "react";
import Anchor from "../Link/anchor";
import "./sectionHeader.css";


const sectionHeader = (props) =>{

    return(
    <div className={props.news?"header-fluid no-fluid":"header-fluid"}>
 <div className="container-header sbgColor ">
    <h3 className="title-width-limit">{props.header?props.title:""}</h3>
    {props.header?<Anchor to={props.link?props.link:""} style={{marginRight:'6px'}}>{props.linkTitle?props.linkTitle:""}</Anchor>:""}
        </div>
    </div>
   );
}
export default sectionHeader;